import React, { useMemo, useState } from "react";
import { Box, Typography } from "@mui/material";
import loucalogo from "../../../assets/Images/louca_logo.png";
import menue from "./menue.json";
import { useLocation, useNavigate } from "react-router-dom";
import { setShowMenu, clearShowMenu } from "../../../Redux/Reducers/GlobalVar";
import { useDispatch, useSelector } from "react-redux";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";

function Menue() {
  const location = useLocation();
  const pathpart = location.pathname.split("/")[2] || "Dashboard";
  const [selectedItem, setSelectedItem] = useState<string>(pathpart);
  const [openMenu, setOpenMenu] = useState<string | null>(null);
  const [subActive, setSubActive] = useState<any>();
  const loginData = useSelector((state: any) => state?.global?.profileData) || 1;



  const [hoverState, setHoverState] = React.useState<{
    row: string | null;
    plus: string | null;
  }>({
    row: null,
    plus: null,
  });
  const [hoveredItem, setHoveredItem] = useState<string | null>(null);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleSelectedItem = (newValue: string) => {
    if (newValue) {
      setSelectedItem(newValue);
      if (
        newValue === "Quick Survey" ||
        newValue === "Manage" ||
        newValue === "Manage Dating"
      ) {
      } else {
        navigate(`/admin/${newValue}`);
      }
    }
  };

  const handleMenuClick = (menuName: string, hasSubMenu: boolean) => {
    if (hasSubMenu) {
      handleSelectedItem(menuName);
      setOpenMenu(openMenu === menuName ? null : menuName);
    } else {
      handleSelectedItem(menuName);
    }
  };
  const handleActive = (sub: any) => {
    setSubActive(sub);
  };

  const menuLabels: Record<string, string> = {
    
    "venue-owner": "Venues",
    LoucaCoins: "Louca Coins",
    LegalContent: "Legal Content",
  };



  const filteredMenus = useMemo(() => {
    return menue
      .filter((menu: any) => {
        if (menu?.roles) {
          return menu.roles.includes(loginData?.role);
        }
        return true;
      })
      .map((menu: any) => {
        if (menu?.subMenu) {
          return {
            ...menu,
            subMenu: menu?.subMenu?.filter((sub: any) => {
              if (sub.roles) {
                return sub.roles.includes(loginData?.role);
              }
              return true;
            })
          };
        }
        return menu;
      })
      .filter((menu: any) => {
        if (menu?.subMenu && menu.subMenu?.length === 0) {
          return false;
        }
        return true;
      });
  }, [loginData?.role]);


  return (
    <Box
      bgcolor="white"
      position="relative"
      className="h-100 sidemenue"
      width="21%"
      maxWidth="250px"
    >
      <Box height="64px" className="logo px-3 px-lg-5 py-3">
        <img src={loucalogo} width="100%" alt="" />
      </Box>

      <Box className="p-3">
        <Box className="dashboard-menue">
          <Box className="my-2 w-100">
            {filteredMenus.map((item) => (
              <Box key={item.menuName} className="w-100">
                <Box
                  onClick={() => handleMenuClick(item.menuName, !!item.subMenu)}
                  onMouseEnter={() => setHoveredItem(item.menuName)}
                  onMouseLeave={() => setHoveredItem(null)}
                  sx={{
                    borderRadius: "10px",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    p: 1,
                    mb: 1,
                    color: selectedItem === item.menuName ? "white" : "inherit",
                    bgcolor:
                      selectedItem === item.menuName ? "black" : "transparent",
                    "&:hover": { bgcolor: "black", color: "white" },
                  }}
                >
                  <img
                    height="24px"
                    src={require(`../../../assets/Images/SideMenueIcons/${selectedItem === item?.menuName ||
                      hoveredItem === item?.menuName
                      ? item.selectedLogo
                      : item.defaultLogo
                      }`)}
                    alt=""
                  />
                  <Typography style={{ width: "100%" }}>
                    {menuLabels[item?.menuName] || item?.menuName}
                  </Typography>
                  {item.subMenu && (
                    <ArrowRightIcon
                      sx={{
                        transform:
                          openMenu === item.menuName
                            ? "rotate(-90deg)"
                            : "rotate(90deg)",
                        transition: "transform 0.3s ease",
                      }}
                    />
                  )}
                </Box>

                {item.subMenu && openMenu === item.menuName && (
                  <Box
                    pl={2}
                    pr={2}
                    display="flex"
                    flexDirection="column"
                    gap={1}
                    sx={{
                      maxHeight: "40vh",
                      overflowY: "auto",
                      marginBottom: "10px",
                      "&::-webkit-scrollbar": {
                        width: "5px",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "black",
                        borderRadius: "6px",
                      },
                      "&::-webkit-scrollbar-thumb:hover": {
                        backgroundColor: "#555",
                      },
                    }}
                  >
                    {item.subMenu.map((sub: any) => {
                      const isRowHover = hoverState.row === sub.menuName;
                      const isPlusHover = hoverState.plus === sub.menuName;
                      const isActive = subActive === sub.menuName;

                      return (
                        <Typography
                          key={sub.menuName}
                          sx={{
                            cursor: "pointer",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "7px 10px",
                            marginLeft: "10px",
                            fontSize: "0.85rem",
                            borderRadius: "6px",
                            transition: "all 0.3s ease",
                            backgroundColor: isPlusHover
                              ? "white"
                              : isRowHover || isActive
                                ? "black"
                                : "transparent",
                            color: isPlusHover
                              ? "black"
                              : isRowHover || isActive
                                ? "white"
                                : "black",
                          }}
                          onMouseEnter={() =>
                            setHoverState({ row: sub.menuName, plus: null })
                          }
                          onMouseLeave={() =>
                            setHoverState({ row: null, plus: null })
                          }
                          onClick={() => {
                            handleActive(sub.menuName);
                            navigate(`/admin/${sub.url}`);
                          }}
                        >
                          <div
                            onClick={() => {
                              navigate(`/admin/${sub.url}`);
                              dispatch(clearShowMenu());
                            }}
                          >
                            {sub.menuName}
                          </div>

                          {sub.plus && (
                            <button
                              style={{
                                backgroundColor: isPlusHover ? "black" : "#fff",
                                color: isPlusHover ? "white" : "black",
                                border: "none",
                                borderRadius: "50%",
                                width: "20px",
                                height: "20px",
                                fontSize: "18px",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                transition: "all 0.3s ease",
                              }}
                              onMouseEnter={(e) => {
                                e.stopPropagation();
                                setHoverState({
                                  row: sub.menuName,
                                  plus: sub.menuName,
                                });
                              }}
                              onMouseLeave={(e) => {
                                e.stopPropagation();
                                setHoverState({
                                  row: sub.menuName,
                                  plus: null,
                                });
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                navigate(`/admin/${sub.url}`);
                                dispatch(setShowMenu(`${sub.menuName}`));
                              }}
                            >
                              +
                            </button>
                          )}
                        </Typography>
                      );
                    })}
                  </Box>
                )}
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default Menue;
